<script lang="ts">
    import {dyData, sessionData} from 'general/store';

    import s from './style.module.css';

    const GENDER_CONFIG = {
        Male: {
            text: 'Shop Men’s Eyewear',
            href: '/mens-eyeglasses',
        },
        Female: {
            text: 'Shop Women’s Eyewear',
            href: '/womens-eyeglasses',
        },
        default: {
            text: 'Shop Eyewear',
            href: '/best-sellers',
        },
    };

    $: currentConfig = GENDER_CONFIG[$sessionData.gender] || GENDER_CONFIG.default;

    const clickHandler = () => {
        window.dispatchEvent(new CustomEvent('mfPopup:close'));
        window.location.href = currentConfig.href;
    };
</script>

<button
    class={s.genderButton}
    class:s.closeButtonColor={$dyData.isSmallerScreen}
    type="button"
    on:click={clickHandler}
    aria-label="Gender button"
>
    <span>
        {currentConfig.text}
    </span>
</button>
